export default __webpack_public_path__ + "static/media/counter-bg.2ad17bd1.png";